import { render, staticRenderFns } from "./SortingBucketManagement.vue?vue&type=template&id=752293a7&"
import script from "./SortingBucketManagement.vue?vue&type=script&lang=js&"
export * from "./SortingBucketManagement.vue?vue&type=script&lang=js&"
import style0 from "./SortingBucketManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports